import { memo, useCallback, useMemo, useState } from 'react';
import formatCurrency from '../../../utils/formatCurrency';
import { useOrderContext } from '../../../providers/OrderProvider';
import { socket } from '../../../socket';
import OrderDetailModal from '../../order/modal/OrderDetailModal';
import { STATISTICS_EMPTY_DRILL_ORDERS } from '../../statistics/common/lib/statisticsEmptyStateCopy';
import { ORDER_PRIMARY_PHASE_BADGE_TRACK } from '../../statistics/charts/pipeline/lib/orderPrimaryPhaseConfig';
import { getOverviewDeliveryBadge, getOverviewPaymentBadge, } from '../../statistics/charts/pipeline/OrderPrimaryPhaseOrderTable';
import { sumOrdersTotalPrice } from '../lib/formatTrendDrillOrdersSummary';
import { ChartExplorerOrdersSkeleton } from './ChartExplorerDetailLoading';
import './chart-explorer-layout.css';
const TABLE_HEADERS = [
    { key: 'id', label: '订单编号' },
    { key: 'customer', label: '客户' },
    { key: 'amount', label: '金额' },
    { key: 'status', label: '状态' },
];
function resolveCustomerName(order) {
    return order.customerInfo?.customerName || order.customerName || '未知客户';
}
function StatusPill({ badge }) {
    if (!badge?.text)
        return null;
    const tone = badge.bg === 'success' ? 'ok' : 'warn';
    return <span className={`chart-xpl-otable__pill chart-xpl-otable__pill--${tone}`}>{badge.text}</span>;
}
function ChartExplorerOrdersTable({ orders = [], isLoading = false, emptyMessage = '', }) {
    const { setCurrentOrderOIdState } = useOrderContext();
    const [isOpenModal, setIsOpenModal] = useState(false);
    const list = useMemo(() => (Array.isArray(orders) ? orders : []), [orders]);
    const handleOrderClick = useCallback((orderOId) => {
        setIsOpenModal(true);
        setCurrentOrderOIdState(orderOId);
        socket.emit('join order', orderOId);
    }, [setCurrentOrderOIdState]);
    const totalLabel = useMemo(() => formatCurrency(sumOrdersTotalPrice(list)), [list]);
	if (isLoading && list.length === 0) {
		return <ChartExplorerOrdersSkeleton className='chart-wb-live' />;
	}
    if (list.length === 0) {
        return (<div className="chart-xpl-otable-wrap chart-xpl-otable-wrap--empty chart-wb-live">
				<p className="chart-xpl-otable__empty">{emptyMessage || STATISTICS_EMPTY_DRILL_ORDERS}</p>
			</div>);
    }
    return (<>
			<div className="chart-xpl-otable-wrap chart-wb-live">
				<div className="chart-xpl-otable-scroll">
					<table className="chart-xpl-otable">
						<thead>
							<tr>
								{TABLE_HEADERS.map((header) => (<th key={header.key} className={`chart-xpl-otable__col-${header.key}`}>
										{header.label}
									</th>))}
							</tr>
						</thead>
						<tbody>
							{list.map((order, index) => {
            const paymentBadge = getOverviewPaymentBadge(order);
            const deliveryBadge = getOverviewDeliveryBadge(order);
            const orderKey = String(order._id || order.orderId || index);
            return (<tr key={orderKey}>
										<td className="chart-xpl-otable__col-id">
											{order._id ? (<button type="button" className="chart-xpl-otable__id" onClick={() => handleOrderClick(String(order._id))} aria-label={`查看订单 ${order.orderId ?? ''}`} title="点击查看订单详情">
													{order.orderId || '—'}
												</button>) : (<span className="chart-xpl-otable__id">{order.orderId || '—'}</span>)}
										</td>
										<td className="chart-xpl-otable__col-customer chart-xpl-otable__customer">{resolveCustomerName(order)}</td>
										<td className="chart-xpl-otable__col-amount chart-xpl-otable__amount">{formatCurrency(order.totalPrice ?? 0)}</td>
										<td className="chart-xpl-otable__col-status">
											<div className="chart-xpl-otable__status">
												<StatusPill badge={paymentBadge}/>
												<StatusPill badge={deliveryBadge}/>
												{!paymentBadge && !deliveryBadge ? <span className="chart-xpl-otable__dash">—</span> : null}
											</div>
										</td>
									</tr>);
        })}
						</tbody>
					</table>
				</div>
				<div className="chart-xpl-otable__foot">合计金额: {totalLabel}</div>
			</div>
			<OrderDetailModal setIsOpenModal={setIsOpenModal} isOpenModal={isOpenModal} badgeTrack={ORDER_PRIMARY_PHASE_BADGE_TRACK}/>
		</>);
}
export default memo(ChartExplorerOrdersTable);
